import React from "react";
import Icon from "components/AppIcon";

export default function VendorKPICard({ title, value, change, changeType, icon, iconColor, prefix = "", suffix = "", badge }) {
  const isPositive = changeType === "positive";
  const isNegative = changeType === "negative";

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-[var(--radius-md)] p-4 md:p-5 shadow-[var(--shadow-sm)] flex flex-col gap-3 hover:shadow-[var(--shadow-md)] transition-shadow duration-200">
      <div className="flex items-center justify-between">
        <span className="text-xs md:text-sm text-[var(--color-muted-foreground)] font-[var(--font-caption)] font-medium truncate pr-2">{title}</span>
        <div className="w-9 h-9 rounded-[var(--radius-sm)] flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${iconColor}18` }}>
          <Icon name={icon} size={18} color={iconColor} strokeWidth={2} />
        </div>
      </div>
      <div className="flex items-end justify-between gap-2">
        <span className="text-xl md:text-2xl lg:text-3xl font-bold font-[var(--font-heading)] text-[var(--color-foreground)] leading-none">
          {prefix}{value}{suffix}
        </span>
        {change && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium font-[var(--font-caption)] flex-shrink-0 ${
            isPositive ? "bg-[var(--color-success)]/10 text-[var(--color-success)]" :
            isNegative ? "bg-[var(--color-error)]/10 text-[var(--color-error)]" : "bg-[var(--color-muted)] text-[var(--color-muted-foreground)]"
          }`}>
            <Icon name={isPositive ? "TrendingUp" : isNegative ? "TrendingDown" : "Minus"} size={12} color={isPositive ? "var(--color-success)" : isNegative ? "var(--color-error)" : "var(--color-muted-foreground)"} />
            {change}
          </div>
        )}
        {badge && (
          <span className="px-2 py-0.5 rounded-full text-xs font-medium" style={{ backgroundColor: `${badge?.color}18`, color: badge?.color }}>{badge?.label}</span>
        )}
      </div>
      <p className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)]">vs. previous period</p>
    </div>
  );
}
